import { AxiosRequestConfig } from 'axios'
import request from './request'

const http = {
  get<T>(url: string, parameters: any) {
    const config: AxiosRequestConfig = {
      method: 'get',
      url
    }
    if (parameters) {
      config.params = parameters
    }

    return request(config)
  },

  post<T>(url: string, parameters: any) {
    const config: AxiosRequestConfig = {
      method: 'post',
      url
    }
    if (parameters) {
      config.data = parameters
    }

    return request(config)
  }
}

export default http
